import {Material} from '@domain/materials'
import React from 'react'
import {useFormContext} from 'react-hook-form'

import {useUrlParam} from '../../../routing'
import {getFieldIsDisabled} from '../../helpers/getFieldIsDisabled'
import {useItemDetails} from '../../providers'
import {Field} from '../../types'

import {ConfigControlledField} from './ConfigControlledField'
import {shouldDisableProductionDayTimeField} from './utils/productionDayUtils'

interface SingleFieldProps {
  field: Field
  materials: Material[]
  upmId: string
}

export const SingleField: React.FC<SingleFieldProps> = ({field, materials, upmId}) => {
  const {control, watch, clearErrors} = useFormContext()
  const {userPermissions, latestData} = useItemDetails()
  const plantCode = useUrlParam('plantCode')

  const watchUseCustomProductionDayBoundaries = watch('useCustomProductionDayBoundaries')
  const watchMothballed = watch('mothballed')
  const startDate = watch('commissStartDate')
  const endDate = watch('commissEndDate')

  let fieldDisabled = getFieldIsDisabled(
    field.editPermissionRequired || [],
    latestData,
    userPermissions || [],
    plantCode || ''
  )

  if (field.name === 'productionDayStartTime' || field.name === 'productionDayEndTime') {
    fieldDisabled = shouldDisableProductionDayTimeField(
      field.name,
      watchUseCustomProductionDayBoundaries as string
    )
  }

  const ignoreValidation = watchMothballed === 'true'

  return (
    <ConfigControlledField
      upmId={upmId}
      clearErrors={clearErrors}
      disabled={fieldDisabled}
      control={control}
      field={field}
      materials={materials}
      startDate={startDate}
      endDate={endDate}
      ignoreValidation={ignoreValidation}
      isOptional={field.optional}
    />
  )
}
